// Query params that act as credentials; never send them to analytics.
const SECRET_PARAMS = ['api_key'] as const;
const RELATIVE_BASE = 'http://redact.invalid';

/** Drops credential query params from an absolute or relative URL; unparseable input comes back as is. */
export function redactUrl(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url, RELATIVE_BASE);
  } catch {
    return url;
  }
  if (!SECRET_PARAMS.some((p) => parsed.searchParams.has(p))) return url;
  for (const p of SECRET_PARAMS) parsed.searchParams.delete(p);
  const isAbsolute = /^[a-z][a-z0-9+.-]*:/i.test(url);
  return isAbsolute ? parsed.toString() : `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
